var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    stroke: "none",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5476 4.25C17.8698 4.25 19.7556 6.12632 19.7673 8.44852 19.7784 10.7082 18.0112 12.5619 15.7793 12.6828L15.5688 12.689 7.45592 12.7296C6.01686 12.7368 4.84345 13.8608 4.75531 15.2777L4.75 15.4491V15.5304C4.75 16.9767 5.87905 18.1593 7.30385 18.245L7.46951 18.2499H12C12.4142 18.2499 12.75 18.5857 12.75 18.9999 12.75 19.3796 12.4678 19.6934 12.1018 19.7431L12 19.7499H7.46951C5.20976 19.7499 3.3649 17.9735 3.25516 15.741L3.25 15.4491C3.25 13.1973 5.0143 11.3559 7.23857 11.2358L7.44841 11.2296 15.5613 11.189C17.0632 11.1815 18.2747 9.95789 18.2672 8.45599 18.26 7.01689 17.136 5.84345 15.719 5.75531L15.5476 5.75H11C10.5858 5.75 10.25 5.41421 10.25 5 10.25 4.6203 10.5322 4.30651 10.8982 4.25685L11 4.25H15.5476Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86057 5.875C8.27478 5.875 8.61057 6.21079 8.61057 6.625 8.61057 7.0047 8.32842 7.31849 7.96234 7.36815L7.86057 7.375H3.73557C3.32136 7.375 2.98557 7.03921 2.98557 6.625 2.98557 6.2453 3.26772 5.93151 3.6338 5.88185L3.73557 5.875H7.86057Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68965 1.81723C6.03531 1.66011 6.43774 1.78712 6.63443 2.09983L6.68278 2.18965 9.18278 7.68965C9.35418 8.06673 9.18744 8.51137 8.81035 8.68278 8.46469 8.83989 8.06226 8.71288 7.86557 8.40017L7.81722 8.31035 5.31723 2.81035C5.14582 2.43327 5.31256 1.98863 5.68965 1.81723Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81723 2.18965C4.98863 1.81256 5.43327 1.64582 5.81035 1.81723 6.15601 1.97434 6.32493 2.36106 6.21865 2.71487L6.18278 2.81035 3.68277 8.31035C3.51137 8.68744 3.06673 8.85418 2.68965 8.68278 2.34399 8.52566 2.17507 8.13894 2.28135 7.78513L2.31723 7.68965 4.81723 2.18965Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 1.75C6.41421 1.75 6.75 2.08579 6.75 2.5 6.75 2.8797 6.46785 3.19349 6.10177 3.24315L6 3.25H5.5C5.08579 3.25 4.75 2.91421 4.75 2.5 4.75 2.1203 5.03215 1.80651 5.39823 1.75685L5.5 1.75H6Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1507 14.25H16C15.5858 14.25 15.25 14.5858 15.25 15V18.048C15.25 18.4622 15.5858 18.798 16 18.798H19.1507C20.4066 18.798 21.4247 17.7799 21.4247 16.524L21.4177 16.3516C21.3101 15.1506 20.3296 14.25 19.1507 14.25ZM16.75 17.298V15.75H19.1507C19.5518 15.75 19.8857 16.0568 19.9215 16.4527L19.9254 16.5576C19.9247 16.9515 19.5781 17.298 19.1507 17.298H16.75Z",
    stroke: "none",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.524 17.298H16C15.5858 17.298 15.25 17.6338 15.25 18.048V21C15.25 21.4142 15.5858 21.75 16 21.75H19.524C20.7534 21.75 21.75 20.7534 21.75 19.524L21.7419 19.341C21.6883 18.7928 21.4621 18.3141 21.098 17.95 20.6806 17.5325 20.1144 17.298 19.524 17.298ZM16.75 20.25V18.798H19.524C19.7165 18.798 19.9012 18.8745 20.0374 19.0106 20.1561 19.1294 20.2299 19.2855 20.2464 19.4522L20.2509 19.5611C20.25 19.925 19.925 20.25 19.524 20.25H16.75Z",
    stroke: "none",
    fill: "#323232"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.40c115c1473de92fca2218d540c031ca.svg";
export { ForwardRef as ReactComponent };